import type { NormalizeOAS, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/RenameOrganization', 'post'>;

type Params = {
  organizationName: string;
};

export const renameOrganizationFactory = (apiClient: ApiClient) => {
  const renameOrganization = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    await apiClient['/api/RenameOrganization'].post(requestBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        organizationName: input.organizationName,
      },
    };
  };

  return renameOrganization;
};
